var _defs, _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApiConnections = function SvgApiConnections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3.65,
    y1: 166.57,
    x2: 212.63,
    y2: 20.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3.65,
    y1: 166.57,
    x2: 212.63,
    y2: 20.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2.31,
    y1: 158.06,
    x2: 206.67,
    y2: 11.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 3.59,
    y1: 166.48,
    x2: 212.57,
    y2: 20.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 11.98,
    y1: 178.46,
    x2: 220.96,
    y2: 32.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.06,
    y1: 161.26,
    x2: 208.92,
    y2: 14.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -53.6,
    y1: 84.79,
    x2: 155.38,
    y2: -61.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 60.51,
    y1: 247.79,
    x2: 269.48,
    y2: 101.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 8.46,
    y1: 173.44,
    x2: 217.44,
    y2: 27.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 14.83,
    y1: 182.54,
    x2: 223.81,
    y2: 36.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2.72,
    y1: 165.24,
    x2: 211.7,
    y2: 18.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -3.95,
    y1: 155.71,
    x2: 205.03,
    y2: 9.43,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M144.61,164.92l19.1-19.1-7.55-10.55c3.77-6.11,6.5-12.71,8.15-19.66l12.79-2.11v-27.02l-12.79-2.11c-1.65-6.96-4.39-13.55-8.15-19.66l7.55-10.55-19.1-19.1-10.55,7.55c-2.13-1.31-4.34-2.51-6.6-3.58l-2.5,5.3c4.16,1.97,6.72,3.69,9.27,5.37l9.75-6.98,12.07,12.07-6.98,9.75c5.12,7.77,7.98,13.45,10.35,24.96l11.82,1.95v17.08l-11.82,1.95c-1.86,9.05-3.85,15.08-10.35,24.96l6.98,9.75-12.07,12.07-9.75-6.98c-7.77,5.12-13.45,7.98-24.96,10.35l-1.95,11.82h-17.08l-1.95-11.82c-9-1.85-15.04-3.82-24.96-10.35l-9.75,6.98-12.07-12.07,6.98-9.75c-5.1-7.75-7.97-13.42-10.35-24.96l-11.82-1.95v-17.08l11.82-1.95c1.87-9.08,3.86-15.1,10.35-24.96l-6.98-9.75,12.07-12.07,9.75,6.98c7.73-5.09,13.39-7.97,24.96-10.35l1.95-11.82h17.08l1.95,11.82c3.17.65,5.91,1.18,10.09,2.67l1.97-5.52c-2.25-.8-4.57-1.49-6.92-2.05l-2.11-12.79h-27.02l-2.11,12.79c-6.96,1.65-13.55,4.39-19.66,8.15l-10.55-7.55-19.1,19.1,7.55,10.55c-3.77,6.11-6.5,12.71-8.15,19.66l-12.79,2.11v27.02l12.79,2.11c1.65,6.96,4.39,13.55,8.15,19.66l-7.55,10.55,19.1,19.1,10.55-7.55c6.11,3.77,12.7,6.5,19.66,8.15l2.11,12.79h27.02l2.11-12.79c6.96-1.65,13.55-4.39,19.66-8.15l10.55,7.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.44,99.99c0,10.76,3.9,21.13,10.99,29.21l4.41-3.86c-6.15-7.01-9.53-16.01-9.53-25.35,0-21.21,17.26-38.47,38.47-38.47s38.47,17.26,38.47,38.47-17.26,38.47-38.47,38.47c-9.2,0-18.1-3.3-25.07-9.29l-3.82,4.44c8.03,6.9,18.29,10.7,28.89,10.7,24.45,0,44.33-19.89,44.33-44.33s-19.89-44.33-44.33-44.33-44.33,19.89-44.33,44.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.08,115.21v-30.66h-20.54v30.66h5.86v-10.93h8.82v10.93h5.86ZM85.22,98.41h-8.82v-8h8.82v8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.35,84.55h-20.54v30.66h5.86v-11.14h0s14.68,0,14.68,0v-19.51ZM110.49,98.2h-8.82v-7.79h8.82v7.79Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 121.16,
    y: 84.77,
    width: 5.86,
    height: 30.44
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M176.35,0c-7.75,0-14.05,6.3-14.05,14.05,0,6.74,4.77,12.39,11.12,13.74v42.94h-3.17v5.86h9.03V27.79c6.34-1.35,11.12-7,11.12-13.74,0-7.75-6.3-14.05-14.05-14.05ZM176.35,22.24c-4.52,0-8.19-3.67-8.19-8.19s3.67-8.19,8.19-8.19,8.19,3.67,8.19,8.19-3.67,8.19-8.19,8.19Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M24.1,28.1c6.66,0,12.24-4.66,13.68-10.88h30.1v11.93h5.86V11.35h-35.85c-1.26-6.46-6.96-11.35-13.79-11.35-7.75,0-14.05,6.3-14.05,14.05s6.3,14.05,14.05,14.05ZM24.1,5.86c4.52,0,8.19,3.67,8.19,8.19s-3.67,8.19-8.19,8.19-8.19-3.67-8.19-8.19c0-4.52,3.67-8.19,8.19-8.19Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M171.76,171.9c-6.93,0-12.71,5.05-13.84,11.66h-29.94v-12.09h-5.86v17.95h36.03c1.55,6.07,7.07,10.57,13.61,10.57,7.75,0,14.05-6.3,14.05-14.05s-6.3-14.05-14.05-14.05ZM171.76,194.14c-4.52,0-8.19-3.67-8.19-8.19s3.67-8.19,8.19-8.19,8.19,3.67,8.19,8.19-3.67,8.19-8.19,8.19Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M26.58,172.21v-41.77h1.18v-5.86h-7.04v47.63c-6.34,1.35-11.12,7-11.12,13.74,0,7.75,6.3,14.05,14.05,14.05s14.05-6.3,14.05-14.05c0-6.74-4.77-12.39-11.12-13.74ZM23.65,194.14c-4.52,0-8.19-3.67-8.19-8.19s3.67-8.19,8.19-8.19,8.19,3.67,8.19,8.19-3.67,8.19-8.19,8.19Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.83,99.99c0-8.96-2.11-17.67-6.19-25.59l-5.21,2.68c3.68,7.16,5.54,14.96,5.54,22.91h5.86Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M137.32,67.87c1.18,1.41,2.29,2.9,3.31,4.44l4.88-3.24c-1.13-1.71-2.38-3.37-3.7-4.95l-4.5,3.76Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.35,60.2c1.45,1.12,2.86,2.34,4.19,3.61l4.06-4.22c-1.48-1.43-3.06-2.78-4.68-4.03l-3.58,4.64Z"
  })));
};
export default SvgApiConnections;